// extracted by mini-css-extract-plugin
module.exports = {"my-account":"style_my-account__ctDTq","referral-link-container":"style_referral-link-container__YCU0n","referral-link":"style_referral-link__CflWS"};